import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import "./CountdownModal.scss";
import AccessAlarmOutlinedIcon from "@mui/icons-material/AccessAlarmOutlined";
import SvgIcon from "@mui/material/SvgIcon";
import { useDispatch } from "react-redux";
import ReservationService from "../api/ReservationService";
interface CountdownModalProps {
  remainingTime: number;
  reservationId?: string;
  companyId?: string;
  processLockVersion?: number;
}

const CountdownModal: React.FC<CountdownModalProps> = ({
  remainingTime,
  reservationId,
  companyId,
  processLockVersion
}) => {
  const [time, setTime] = useState(
    window.location.pathname === "/finish" ? 10 : remainingTime
  );
  const history = useHistory();
  const dispatch = useDispatch();
  const activityTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const [showModal, setShowModal] = useState(false);
  const onClose = () => {
    dispatch({ type: "DRIVER_CLEAR" });
    dispatch({ type: "RESERVATION_ONE" });
    dispatch({ type: "PRODUCT" });
    dispatch({ type: "CARINFO" });
  };

  const startTimer = () => {
    if (activityTimeoutRef.current !== null) {
      clearTimeout(activityTimeoutRef.current as NodeJS.Timeout);
    }

    activityTimeoutRef.current = setTimeout(
      () => {
        setShowModal(true);
        console.log("사용자가 60초 동안 활동이 없습니다.");
      },
      window.location.pathname === "/finish" ? 10000 : 60000
    ); // 60초를 밀리초로 변환
  };

  const handleUserActivity = () => {
    startTimer();

    console.log("사용자가 활동 중입니다.");
  };

  const processOpen = async () => {
    
    if(companyId && reservationId && processLockVersion) {
      ReservationService.processOpen(
        companyId, reservationId, processLockVersion
      ).then((res) => {
        if (res.data.status === 200) {
          history.push("/main");
        }
      });
    } else {
      history.push("/main");
    }
    
  };

  // 사용자 동작 감지 이벤트 등록
  useEffect(() => {
    startTimer();

    return () => {
      if (activityTimeoutRef.current !== null) {
        clearTimeout(activityTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    window.addEventListener("touchstart", handleUserActivity);

    // 컴포넌트 언마운트 시 이벤트 리스너 정리 및 타임아웃 제거
    return () => {
      window.removeEventListener("touchstart", handleUserActivity);
      if (activityTimeoutRef.current !== null) {
        clearTimeout(activityTimeoutRef.current as NodeJS.Timeout);
      }
    };
  }, []);

  useEffect(() => {
    if (time === 0) {
      // dispatch({ type: "CARINFO" });
      if (process.env.REACT_APP_ENV === "prod") {
        // history.push("/main");
        processOpen();
        dispatch({ type: "DRIVER_CLEAR" });
        dispatch({ type: "DRIVER" });
        dispatch({ type: "RESERVATION_ONE" });
        dispatch({ type: "PRODUCT" });
        dispatch({ type: "PRODUCT_RESET" });
      }
    }
  }, [time]);

  useEffect(() => {
    if (showModal) {
      const interval = setInterval(() => {
        setTime((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [showModal]);

  return (
    <>
      {showModal && (
        <div className="countdown-overlay">
          <div className="countdown-modal-wrap">
            <h2>대기시간이 초과되었습니다.</h2>
            <p
              dangerouslySetInnerHTML={{
                __html:
                  "응답이 없어 첫 화면으로 돌아갑니다. <br/> 서비스를 계속 하시려면 오른쪽 버튼을 클릭해주세요." ||
                  ""
              }}
            ></p>
            <div className="countdown-timer-wrap">
              <span className="ment">첫 화면 이동까지</span>
              <div className="timer">
                <SvgIcon
                  component={AccessAlarmOutlinedIcon}
                  style={{
                    fontSize: "1.4em",
                    marginRight: "5px",
                    color: "#3e83f1"
                  }}
                ></SvgIcon>
                {time}초...
              </div>
            </div>

            <div className="countdown-button-wrap">
              <button
                onClick={() => {
                  dispatch({ type: "DRIVER_CLEAR" });
                  dispatch({ type: "RESERVATION_ONE" });
                  dispatch({ type: "PRODUCT" });
                  dispatch({ type: "PRODUCT_RESET" });
                  // dispatch({ type: "CARINFO" });
                  processOpen();
                }}
                className="cancel"
              >
                첫 화면으로
              </button>
              <button
                onClick={() => {
                  startTimer();
                  setShowModal(false);
                  setTime(60);
                }}
                className="countdown"
              >
                계속 이용할래요!
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CountdownModal;
